<div class="app-body">
  <!-- Menu content -->
  <div [ngClass]="{ menu: sidebarOpen, 'menu-closed': sidebarOpen === false }">
    <div class="sidebar" [ngStyle]="{ width: sidebarOpen ? '200px' : '50px' }">
      <div  *ngIf="!production" class="testing-banner" [ngStyle]="{ 'font-size': !sidebarOpen ? 'x-small' : 'small' }" >
        Testing
      </div>
      <!-- Logo-->
      <div style="display: inline-block">
        <img
          [ngClass]="sidebarOpen ? 'logo' : 'logo-closed'"
          [src]="sidebarOpen ? 'assets/img/brand/full-white.png' : 'assets/img/brand/full-white-logo.png'"
          width="120"
          alt="Logo" />
        <span class="sidebar-has-tooltip">
          <span class="sidebar-tooltip" *ngIf="sidebarOpen" style="margin-top: 5px">Hide Sidebar</span>
          <span class="sidebar-tooltip" *ngIf="!sidebarOpen" style="margin-top: 55px; margin-left: 7px"
            >Expand Sidebar</span
          >
          <i
            (click)="toggleSidebar()"
            [ngClass]="sidebarOpen ? 'chev-left fa fa-chevron-left' : 'chev-right fa fa-chevron-right'"></i>
        </span>
      </div>

      <!-- Nav Component-->
      <div class="api-warning" *ngIf="hasCustomAPI">
        You are using a custom API URL for testing purposes.
        <br />Click <a href="javascript:void(0)" (click)="resetAPI()">here</a> to reset to the default API URL for this
        environment.
      </div>
      <app-sidebar-nav [navItems]="navItems" [perfectScrollbar]></app-sidebar-nav>

      <!--Logout button-->
      <div [ngClass]="sidebarOpen ? 'logout' : 'logout-closed'">
        <span class="sidebar-has-tooltip" *ngIf="sidebarOpen === false">
          <span class="sidebar-tooltip" style="margin-top: 0; margin-left: 40px">Logout</span>
          <button type="button" class="btn" (click)="logout()">
            <i class="fa fa-power-off"></i>
          </button>
        </span>
        <button *ngIf="sidebarOpen" type="button" class="btn" (click)="logout()">
          <i class="fa fa-power-off"></i>&nbsp;
          <span>Logout</span>
        </button>
        <ng-container *ngIf="isImpersonated">
          <br />
          <button type="button" class="btn" (click)="leaveImpersonation()" style="color: red">
            Back to Super User!
          </button>
        </ng-container>
      </div>
    </div>
  </div>

  <!-- Main content -->
  <main [ngClass]="{ main: sidebarOpen, 'main-closed': sidebarOpen === false }">
    <div class="container-fluid">
      <router-outlet></router-outlet>
    </div>
  </main>
</div>
